import React from 'react';
import Svg, { Circle, Rect, Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';
import PropTypes from 'prop-types';
import { PALETTE } from '../../../constants';

const InfoDarkIcon = (props) => {
  const {
    color,
    ...svgProps
  } = props;

  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <Path fill-rule="evenodd" clip-rule="evenodd" d="M0 8C0 3.58182 3.58182 0 8 0C12.4182 0 16 3.58182 16 8C16 12.4182 12.4182 16 8 16C3.58182 16 0 12.4182 0 8ZM8.01135 5.05681C8.20451 5.05681 8.3712 4.98674 8.51135 4.84659C8.65149 4.70644 8.7216 4.53977 8.7216 4.34659C8.7216 4.14583 8.65338 3.97727 8.51702 3.84091C8.38066 3.70455 8.21215 3.63636 8.01135 3.63636C7.81818 3.63636 7.65338 3.70644 7.51702 3.84659C7.38065 3.98674 7.31251 4.15341 7.31251 4.34659C7.31251 4.53977 7.38065 4.70644 7.51702 4.84659C7.65338 4.98674 7.81818 5.05681 8.01135 5.05681ZM9.41702 12.3295C9.49738 12.3295 9.56247 12.2644 9.56247 12.1841V11.4295C9.56247 11.3492 9.49738 11.2841 9.41702 11.2841H8.65338V6.50341C8.65338 6.42308 8.58829 6.35796 8.50793 6.35796H6.69091C6.61057 6.35796 6.54545 6.42308 6.54545 6.50341V7.26364C6.54545 7.344 6.61057 7.40909 6.69091 7.40909H7.47724V11.2841H6.69091C6.61057 11.2841 6.54545 11.3492 6.54545 11.4295V12.1841C6.54545 12.2644 6.61057 12.3295 6.69091 12.3295H9.41702Z" fill="#00A3E0"/>
    </Svg>
  );
};

InfoDarkIcon.defaultProps = {
  height: 24,
  width: 24,
  color: PALETTE.touchableOpacityEnable,
};

InfoDarkIcon.PropTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

export default pure(InfoDarkIcon);